// workspace-landing.ts — Construction pure de l'URL d'atterrissage d'une tuile.
//
// Séparé du câblage DOM pour être testable : c'est la pièce dont dépend la
// promesse centrale du Workspace — « le chiffre affiché se retrouve en
// cliquant dessus ». Une facette perdue ici, et la tuile et sa page divergent
// sans que rien ne le signale.
//
// Le front n'INVENTE aucune facette de population : il sérialise celles que le
// serveur a publiées dans `landing`. Les seules qu'il ajoute sont celles du
// geste (quel chiffre a été cliqué), et elles sont énumérées ici.

export interface TileLandingLike {
  page: string;
  facets: Record<string, unknown>;
}

/** Sérialise le `landing` serveur, plus d'éventuelles facettes de geste. */
export function landingHash(
  landing: TileLandingLike | null | undefined,
  extra: Record<string, string> = {},
): string {
  if (!landing) return '#actions';
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries({ ...landing.facets, ...extra })) {
    if (value === null || value === undefined || value === '') continue;
    params.set(key, String(value));
  }
  const qs = params.toString();
  return '#' + landing.page + (qs ? '?' + qs : '');
}

/** Décale une date de `days` jours, sans muter l'originale. */
function shift(from: Date, days: number): Date {
  const d = new Date(from.getTime());
  d.setDate(d.getDate() + days);
  return d;
}

/** `YYYY-MM-DD` en heure LOCALE — `toISOString()` décalerait d'un jour à l'est. */
export function isoDay(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Facette portée par le chiffre cliqué.
 *
 * « 6 en retard » doit ouvrir la liste des 6, pas celle des 43 : chaque
 * compteur restreint l'atterrissage à sa propre tranche.
 */
export function facetForKpi(facet: string | undefined, today: Date = new Date()) {
  if (facet === 'late') return { late_only: 'true' };
  if (facet === 'soon') return { due_from: isoDay(today), due_to: isoDay(shift(today, 7)) };
  if (facet === 'new' || facet === 'changed') return { seen_state: facet };
  return {};
}
